export const LOGO_URL = 'https://upload.wikimedia.org/wikipedia/en/b/b5/National_Institute_of_Technology%2C_Patna_Logo.png';
export const BASE_URL =  'https://alumni-community-new.vercel.app/api/v1';
// export const BASE_URL =  'http://localhost:8080/api/v1';